module.exports = "//static.hsappstatic.net/LoginUI/static-1.14876/img/SUI_mobile.svg"